import { ctxTargetAttributes } from '@/contexts/TargetAttributesContext';
import { useContext } from 'react';
import MultiTargetSelector from '@/components/common/selection/MultiTargetSelector';

export default function TargetAttributesTargetSelector() {
  const targetAttrCtx = useContext(ctxTargetAttributes);
  if (!targetAttrCtx) return;

  return (
    <MultiTargetSelector
      selectedTargets={targetAttrCtx.selectedTargets}
      setSelectedTargets={targetAttrCtx.setSelectedTargets}
      searchText={targetAttrCtx.searchText}
      setSearchText={targetAttrCtx.setSearchText}
      maxElementNumber={targetAttrCtx.maxTargetNumber}
    />
  );
}
